import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { I18n } from '@td/shared_utils';
import { get } from 'lodash';
import moment from 'moment';

import MedicationFormulariesHeader from '../medication-formularies-header';
import DRUG_SUMMARY from '../../queries/drug-summary.graphql';
import Loader from '../../../lib/loader';
import useQueryParams from '../../../lib/hooks/useQueryParams';
import MedicationAvailability from './medication-availability';
import MedicationIdentifiers from './medication-identifiers';
import MedicationForms from './medication-forms';

import '../styles.scss';

export const DRUG_SUMMARY_DRUG_ID_TYPE = 'DRUGID';

const MedicationFormulariesDetails = ({ drugId }) => {
  const { data, loading, error } = useQuery(DRUG_SUMMARY, {
    variables: {
      drugId,
      drugIdType: DRUG_SUMMARY_DRUG_ID_TYPE
    }
  });

  const { search_term: searchTerm } = useQueryParams();

  return (
    <Fragment>
      <MedicationFormulariesHeader redirectOnClear />
      <section className="medication-details">
        {loading && <Loader />}
        {error && (
          <span>
            <I18n scope="medication_formularies.details" text="error" options={{ drug_id: drugId }} />
          </span>
        )}
        {data && (
          <Fragment>
            <h3>
              <I18n
                scope="medication_formularies.details"
                text="title"
                options={{
                  drug_name: searchTerm || get(data, ['drugSummary', 'genericDrug', 'drugName']),
                  formatted_date: moment().format('L')
                }}
              />
            </h3>
            <MedicationIdentifiers searchTerm={searchTerm} drug={get(data, 'drugSummary')} />
            <MedicationAvailability
              drugListMaps={get(data, 'drugListMaps')}
              drugId={get(data, ['drugSummary', 'drugId'])}
              refStates={get(data, 'refStates')}
            />
            <MedicationForms drug={get(data, 'drugSummary')} />
          </Fragment>
        )}
      </section>
    </Fragment>
  );
};

MedicationFormulariesDetails.propTypes = {
  drugId: PropTypes.string.isRequired
};

export default MedicationFormulariesDetails;
